import Form from '~components/form/js';

const IS_LOADING = 'is--loading';

class FormExtend extends Form {
    constructor(element) {
        super(element);

        this.subjects = this.element.querySelector('[name="subject"]');
		if(this.subjects) this.subjects.addEventListener("change", (event) => this.subjectChange(event));
		
    }
	
	subjectChange() {
        const subjectsHidden = this.element.querySelector("[name='subjects_hidden']");
		const subjectsLabel = this.subjects.nextElementSibling.innerText;
		console.log(subjectsHidden, subjectsLabel);
		if(subjectsHidden && subjectsLabel) subjectsHidden.value = subjectsLabel;
	}

    showErrorData() {
        
    }

    responseMessage(error) {
		this.element.classList.remove(IS_LOADING);

		const errorElement = this.element.querySelector('[js-form-error]');
		const successElement = this.element.querySelector('[js-form-success]');

		if (error) {
			successElement.classList.remove('is--active');
			errorElement.classList.add('is--active');
		} else {
			this.element.classList.add('is--send');
			successElement.classList.add('is--active');
			errorElement.classList.remove('is--active');
		}
	}
}

export default FormExtend;
